/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    ChunkedListBase,
    ChunkedListBaseFromJSON,
    ChunkedListBaseFromJSONTyped,
    ChunkedListBaseToJSON,
    UserInfo,
    UserInfoFromJSON,
    UserInfoFromJSONTyped,
    UserInfoToJSON,
    UserInfoListChunkAllOf,
    UserInfoListChunkAllOfFromJSON,
    UserInfoListChunkAllOfFromJSONTyped,
    UserInfoListChunkAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserInfoListChunk
 */
export interface UserInfoListChunk {
    /**
     * 
     * @type {number}
     * @memberof UserInfoListChunk
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof UserInfoListChunk
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof UserInfoListChunk
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof UserInfoListChunk
     */
    pageCount: number;
    /**
     * 
     * @type {Array<UserInfo>}
     * @memberof UserInfoListChunk
     */
    chunk: Array<UserInfo>;
}

export function UserInfoListChunkFromJSON(json: any): UserInfoListChunk {
    return UserInfoListChunkFromJSONTyped(json, false);
}

export function UserInfoListChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInfoListChunk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
        'totalCount': json['totalCount'],
        'pageCount': json['pageCount'],
        'chunk': ((json['chunk'] as Array<any>).map(UserInfoFromJSON)),
    };
}

export function UserInfoListChunkToJSON(value?: UserInfoListChunk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
        'totalCount': value.totalCount,
        'pageCount': value.pageCount,
        'chunk': ((value.chunk as Array<any>).map(UserInfoToJSON)),
    };
}


